
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'data-privacy-request-ui',
  currentProjectVersion: 'static-1.5653',
  depVersions: {
  "data-privacy-request-ui": "static-1.5653",
  "data-fetching-client": "static-1.9799",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8161",
  "hub-http-shared-msw-handlers": "static-1.10304",
  "hubspot-dlb": "static-2.1854",
  "HubStyleTokens": "static-2.11611",
  "I18n": "static-7.1643",
  "jasmine-runner": "static-1.6596",
  "privacy-center-public-service-types": "static-1.4916",
  "quartz": "static-1.7216",
  "react-dlb": "static-1.81",
  "ui-components-test-utils": "static-1.5748",
  "UIComponents": "static-3.8557",
  "webpack-env": "static-1.54",
  "apollo-stack-hubspot": "static-3.88",
  "foundations-assets": "static-1.5013",
  "foundations-components": "static-1.8211",
  "foundations-components-test-utils": "static-1.5694",
  "foundations-theming": "static-1.4574",
  "hub-http": "static-1.6360",
  "quartz-config": "static-1.994",
  "quartz-core": "static-1.6435",
  "quartz-routing": "static-1.646",
  "quick-fetch": "static-1.4024",
  "raven": "static-3.5925",
  "react": "static-7.187",
  "react-rhumb": "static-1.16827",
  "SharedI18nStrings": "static-1.182",
  "ui-addon-i18n": "static-1.11288",
  "usage-tracker": "static-1.7492",
  "usage-tracker-anonymous": "static-1.5909",
  "usage-tracker-core": "static-1.7342",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "hubspot-url-utils": "static-1.4132",
  "immutable": "static-2.79",
  "metrics-js": "static-1.9637",
  "react-redux": "static-7.71",
  "redux": "static-4.16",
  "styled-components": "static-2.89",
  "bend-plugin-trellis-migration": "static-1.3507",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3493",
  "quartz-webpack": "static-1.3440",
  "bend-plugin-quartz-routing": "static-1.294",
  "fast-json-stable-stringify": "static-1.4",
  "graphql": "static-1.84",
  "HeadJS": "static-2.775",
  "framer-motion": "static-1.74",
  "hs-test-utils-bend-plugin": "static-1.3272",
  "msw": "static-1.39",
  "testing-library": "static-1.154",
  "ts-schema": "static-1.4187",
  "i18n-data": "static-1.224",
  "moment-timezone": "static-5.85",
  "react-utils": "static-2.5447",
  "StyleGuideUI": "static-3.490",
  "jasmine": "static-4.4464",
  "rpc-client-utils": "static-1.4796",
  "HubStyle": "static-2.11918",
  "ui-addon-draggable": "static-3.4900",
  "cssUtils": "static-1.835",
  "hs-story-utils": "static-1.9562",
  "icons": "static-2.658",
  "react-create-root-preference": "static-1.41",
  "react-select-plus": "static-1.107",
  "react-virtualized": "static-2.101",
  "ui-images": "static-2.1193",
  "bend-plugin-foundations-components": "static-1.4480",
  "floating-ui": "static-1.59",
  "foundations-theming-specialty": "static-1.2290",
  "react-aria": "static-1.68",
  "tanstack-table": "static-1.57",
  "trellis-assets": "static-1.2225",
  "ui-fonts": "static-1.873",
  "foundations-components-legacy": "static-1.1236",
  "bend-plugin-foundations-theming": "static-1.3057",
  "foundations-theming-base": "static-1.3559",
  "stylex": "static-1.36",
  "hs-locale-management": "static-1.187",
  "dispatcher": "static-1.139",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.850",
  "hubspotter-http": "static-1.4756",
  "mobile-manifest-mixins": "static-1.549",
  "module-federation": "static-1.28",
  "quartz-auth": "static-1.891",
  "quartz-head": "static-1.881",
  "quartz-i18n": "static-1.891",
  "quartz-test": "static-1.891",
  "quartz-tracking": "static-1.595",
  "trellis-components": "static-1.2244",
  "usage-tracker-container": "static-1.7482",
  "csstype": "static-1.50",
  "web-vitals": "static-1.8",
  "react-input-autosize": "static-2.17",
  "bender-build-tools": "static-1.3301",
  "bend-plugin-chirp-manifest": "static-1.206",
  "chirp-fetch": "static-1.2027",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "react-flip-move": "static-1.73",
  "sassPrefix": "static-1.158",
  "hubspotter-http-shared-msw-handlers": "static-1.10302",
  "usage-tracker-session-replay": "static-1.5178",
  "base-ui": "static-1.16",
  "react-day-picker": "static-1.5",
  "trellis-theming": "static-1.1082",
  "tanstack-virtual": "static-1.32",
  "amplitude-session-replay-browser": "static-1.60"
},
  depPathPrefixes: {
  "data-privacy-request-ui": "/data-privacy-request-ui/static-1.5653",
  "data-fetching-client": "/data-fetching-client/static-1.9799",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8161",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10304",
  "hubspot-dlb": "/hubspot-dlb/static-2.1854",
  "HubStyleTokens": "/HubStyleTokens/static-2.11611",
  "I18n": "/I18n/static-7.1643",
  "jasmine-runner": "/jasmine-runner/static-1.6596",
  "privacy-center-public-service-types": "/privacy-center-public-service-types/static-1.4916",
  "quartz": "/quartz/static-1.7216",
  "react-dlb": "/react-dlb/static-1.81",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.5748",
  "UIComponents": "/UIComponents/static-3.8557",
  "webpack-env": "/webpack-env/static-1.54",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.88",
  "foundations-assets": "/foundations-assets/static-1.5013",
  "foundations-components": "/foundations-components/static-1.8211",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5694",
  "foundations-theming": "/foundations-theming/static-1.4574",
  "hub-http": "/hub-http/static-1.6360",
  "quartz-config": "/quartz-config/static-1.994",
  "quartz-core": "/quartz-core/static-1.6435",
  "quartz-routing": "/quartz-routing/static-1.646",
  "quick-fetch": "/quick-fetch/static-1.4024",
  "raven": "/raven/static-3.5925",
  "react": "/react/static-7.187",
  "react-rhumb": "/react-rhumb/static-1.16827",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11288",
  "usage-tracker": "/usage-tracker/static-1.7492",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5909",
  "usage-tracker-core": "/usage-tracker-core/static-1.7342",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4132",
  "immutable": "/immutable/static-2.79",
  "metrics-js": "/metrics-js/static-1.9637",
  "react-redux": "/react-redux/static-7.71",
  "redux": "/redux/static-4.16",
  "styled-components": "/styled-components/static-2.89",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3507",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3493",
  "quartz-webpack": "/quartz-webpack/static-1.3440",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.294",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "graphql": "/graphql/static-1.84",
  "HeadJS": "/HeadJS/static-2.775",
  "framer-motion": "/framer-motion/static-1.74",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3272",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.154",
  "ts-schema": "/ts-schema/static-1.4187",
  "i18n-data": "/i18n-data/static-1.224",
  "moment-timezone": "/moment-timezone/static-5.85",
  "react-utils": "/react-utils/static-2.5447",
  "StyleGuideUI": "/StyleGuideUI/static-3.490",
  "jasmine": "/jasmine/static-4.4464",
  "rpc-client-utils": "/rpc-client-utils/static-1.4796",
  "HubStyle": "/HubStyle/static-2.11918",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4900",
  "cssUtils": "/cssUtils/static-1.835",
  "hs-story-utils": "/hs-story-utils/static-1.9562",
  "icons": "/icons/static-2.658",
  "react-create-root-preference": "/react-create-root-preference/static-1.41",
  "react-select-plus": "/react-select-plus/static-1.107",
  "react-virtualized": "/react-virtualized/static-2.101",
  "ui-images": "/ui-images/static-2.1193",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4480",
  "floating-ui": "/floating-ui/static-1.59",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2290",
  "react-aria": "/react-aria/static-1.68",
  "tanstack-table": "/tanstack-table/static-1.57",
  "trellis-assets": "/trellis-assets/static-1.2225",
  "ui-fonts": "/ui-fonts/static-1.873",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1236",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3057",
  "foundations-theming-base": "/foundations-theming-base/static-1.3559",
  "stylex": "/stylex/static-1.36",
  "hs-locale-management": "/hs-locale-management/static-1.187",
  "dispatcher": "/dispatcher/static-1.139",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.850",
  "hubspotter-http": "/hubspotter-http/static-1.4756",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.549",
  "module-federation": "/module-federation/static-1.28",
  "quartz-auth": "/quartz-auth/static-1.891",
  "quartz-head": "/quartz-head/static-1.881",
  "quartz-i18n": "/quartz-i18n/static-1.891",
  "quartz-test": "/quartz-test/static-1.891",
  "quartz-tracking": "/quartz-tracking/static-1.595",
  "trellis-components": "/trellis-components/static-1.2244",
  "usage-tracker-container": "/usage-tracker-container/static-1.7482",
  "csstype": "/csstype/static-1.50",
  "web-vitals": "/web-vitals/static-1.8",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "bender-build-tools": "/bender-build-tools/static-1.3301",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.206",
  "chirp-fetch": "/chirp-fetch/static-1.2027",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "react-flip-move": "/react-flip-move/static-1.73",
  "sassPrefix": "/sassPrefix/static-1.158",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10302",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5178",
  "base-ui": "/base-ui/static-1.16",
  "react-day-picker": "/react-day-picker/static-1.5",
  "trellis-theming": "/trellis-theming/static-1.1082",
  "tanstack-virtual": "/tanstack-virtual/static-1.32",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60"
}
};
